<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <list
          :entity-id="entityId"
          :edit="edit"
          @form="dialog = true"
          @clear="$refs.form && $refs.form.clear()"
        />
        <form-manager
          v-if="dialog"
          ref="form"
          :dialog="dialog"
          :entity-id="entityId"
          :edit="edit"
          @close="dialog = false"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FormManager from './FormManager'
import List from './List'
export default {
  name: 'Teams',
  components: {
    List,
    FormManager,
  },
  props: {
    entityId: {
      type: String,
      default: '',
      required: false,
    },
    entityView: {
      type: Boolean,
      default: false,
      required: false,
    },
    edit: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  mounted() {
    // this.resetState()
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
  },
  methods: {
    ...mapActions({
      fetchTeams: 'teams/fetchList',
      resetState: 'teams/resetState',
      setStatus: 'events/setStatus',
    }),
    async initData() {
      // if (!this.entityId) this.resetPagitations()
      // this.resetPagitations()
      // let params = { limit: 0 }
      // if (this.entityId) params.entityId = this.entityId
      if (!this.entityView) {
        await Promise.all([this.fetchTeams()])
      }
      if (this.entityId) {
        this.resetState()
        this.fetchTeams({ entityId: this.entityId })
      }
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    },
    entityId(val) {
      if (val) {
        this.resetState()
        this.fetchTeams({ entityId: val })
      }
    },
  },
}
</script>
